<template>
    <ErrorPage>
        <template slot="Title">
            This looks empty
        </template>
        <template slot="SubTitle">
        </template>
        <template slot="Content">
            Try creating your first box then drag tracks in it!
        </template>
        <template slot="Actions">
            <BoxCreationButton :empty="false">Create new Box</BoxCreationButton>
        </template>
    </ErrorPage>
</template>

<script>
    import BoxCreationButton from './BoxCreationButton.vue'
    import ErrorPage from'@/components/common/ErrorPage.vue'
    export default {
        name: "BoxListEmptyCard",
        components: {
            BoxCreationButton, ErrorPage
        },
    }
</script>

<style scoped>
</style>